// French

const lang = {
  gateMediaPreviewHeader: 'Vous aimerez aussi',
  loadmore: 'Voir plus',
  nextMedia: 'Média suivant',
  previousMedia: 'Médias précédents',
  closePost: 'Fermer la publication',
  nextPost: 'Publication suivante',
  previousPost: 'Publication précédente',
  outOfStock: 'En rupture de stock',
  numberOfReviews() {
    return 'avis'
  },
  reportFormField: 'Veuillez saisir un message',
  reportPost: 'Signaler la publication',
  reportFormTitle: 'Souhaitez-vous signaler ce contenu ?',
  reportFormDetails:
    'Si vous considérez ce contenu comme inapproprié, indésirable ou portant atteinte aux droits individuels, vous pouvez le signaler ci-dessous. Si vous signalez ce contenu, les modérateurs en charge de ce contenu seront automatiquement notifiés et prendront les mesures nécessaires.',
  reportFormMessagePlaceholder: 'Indiquez la raison de votre signalement',
  reportFormMessageLabel: 'Votre message',
  reportFormEmailLabel: 'Votre email',
  reportFormSubmitButtonText: 'Envoyer un rapport',
  reportFormCancelButtonText: 'Annuler',
  reportFormSentTitle: 'Merci pour votre rapport !',
  reportFormSentCloseButtonText: 'Fermer',
  cardAndTileAriaLabel:
    'Ci-dessous se trouve une liste de publications de comptes sur différents réseaux sociaux',
  carouselAriaLabel:
    'Ci-dessous se trouve un carrousel avec des publications de comptes sur différents réseaux sociaux',
  singleAriaLabel: 'Ci-dessous, une publication d’un compte d’un réseau social',
  poweredBy: 'Proposé par Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publiée à ${date}` : ''
    const createdByString = userName ? ` de ${userName}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Téléchargez vos médias',
  openTheGate: 'Ouvrir la boîte de dialogue',
}

export default lang
